import useAppStore from '@/store/app.store';
import NProgress from 'nprogress';
import type { Router } from 'vue-router';
import { useCommon } from '@/hooks/core/useCommon';
import { loadingUtils } from '@/utils/loading';
import { getPendingLoading, resetPendingLoading } from './beforeEach';

export function setupAfterEach(router: Router) {
  const appStore = useAppStore();
  const { scrollToTop } = useCommon();

  router.afterEach(() => {
    scrollToTop();

    if (appStore.showNprogress) {
      NProgress.done();
      // 确保进度条完全移除，避免残影
      setTimeout(() => {
        NProgress.remove();
      }, 600);
    }

    //关闭 loading 效果
    if (getPendingLoading()) {
      nextTick(() => {
        loadingUtils.hideLoading();
        resetPendingLoading();
      });
    }
  });
}